import { render, staticRenderFns } from "./AddPromoCode.vue?vue&type=template&id=12e23349"
import script from "./AddPromoCode.vue?vue&type=script&lang=js"
export * from "./AddPromoCode.vue?vue&type=script&lang=js"
import style0 from "./AddPromoCode.vue?vue&type=style&index=0&id=12e23349&prod&lang=css"
import style1 from "./AddPromoCode.vue?vue&type=style&index=1&id=12e23349&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports